import SignIn from "../../views/authentication/SignIn";
import SignUp from "../../views/authentication/SignUp";
import ForgotPassword from "../../views/authentication/ForgotPassword";
import SignInWithAmazon from "../../views/authentication/desktop/SignInWithAmazon";
import SignUpWithAmazon from "../../views/authentication/desktop/SignUpWithAmazon";

export default [
  {
    path: "/ap/signin",
    component: SignIn,
    name : "signin",
    props: route => ({
      redirect: route.query.redirect,
    })
  },
  {
    path: "/ap/signup",
    component: SignUp,
    name : "signup",
  },
  {
    path: "/ap/signInWithAmazon",
    component: SignInWithAmazon,
    name : "SignInWithAmazon",

  },
  {
    path: "/ap/signUpWithAmazon",
    component: SignUpWithAmazon,
    name : "SignUpWithAmazon",

  },
  {
    path: "/ap/forgotPassword",
    component: ForgotPassword,
    name : "forgotPassword",

  }
];
